import dynamic from "next/dynamic";
import FullBackgroundHeroConfig from "./full-background-hero-config";
const FullBackgroundHeroComponent = dynamic(()=>import("./full-background-hero-component"));
export default {
    FullBackgroundHeroComponent,
    FullBackgroundHeroConfig
};
